<!--
 * @Author: shijian.chen
 * @Date: 2021-11-09 16:52:12
 * @LastEditTime: 2022-09-02 17:35:57
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: 领克广告
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/ftms/index.vue
-->
<template>
  <div id="main">
    <img
      src="https://source.qunarzz.com/site/images/wns/20220902-shijianchen-1.jpg"
      alt=""
    />
    <img
      src="https://source.qunarzz.com/site/images/wns/20220902-shijianchen-2.jpg"
      alt=""
    />
    <div class="cardBox">
      <a :href="item.link" v-maidian="'note'+index" v-for="(item,index) in noteList" :key="index" class="card">
        <img
          :src="item.img"
          class="card-img"
          alt=""
        />
        <div class="card-cont">
          <div class="card-tit text-overflow">
            {{item.title}}
          </div>
          <div class="card-des">
           {{item.des}}
          </div>
        </div>
      </a>
    </div>
    <img
      src="https://source.qunarzz.com/site/images/wns/20220902-shijianchen-3.jpg"
      alt=""
    />
  </div>
</template>
<script>
import appoint from './components/appoint.vue';
export default {
  data() {
    return {
      imgList: [
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun1.png',
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun2.png',
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun3.png',
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun4.png',
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun5.png',
        'https://source.qunarzz.com/site/images/wns/20220721-shijianchen-lun6.png',
      ],
      noteList:[
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img1.jpg',
          title:'我们的自驾呼和浩特之旅',
          des:'北京节庆短途自驾好去处，人不挤路不堵',
          link:'https://touch.travel.qunar.com/youji/7682990?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img2.jpg',
          title:'呼和浩特4日游',
          des:'随性的一次出游，出乎预料的惊喜',
          link:'https://touch.travel.qunar.com/youji/6573441?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img3.jpg',
          title:'有失有得-冬日下呼和浩特之旅',
          des:'去往广袤的蒙古草原----看看大西北的风沙，风吹草低显牛羊情形。',
          link:'https://touch.travel.qunar.com/youji/7565887?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img4.jpg',
          title:'草原风光（敕勒川草原）—网红村（恼包村）',
          des:'一日游往往是短途旅游的首选，时间适中，刚好不劳累。',
          link:'https://touch.travel.qunar.com/youji/7696020?bd_source=RN&showType=share'
        },

        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img5.jpg',
          title:'手把手教你get青城美景',
          des:'这座城，秋天会一夜之间满地落叶，冬天白雪皑皑，春天的花也争相斗艳，但夏天，才是这个地方的旅游旺季。',
          link:'https://touch.travel.qunar.com/youji/7694256?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img6.jpg',
          title:'何留青冢向黄昏',
          des:'呼市的公交报站都是先用蒙语然后汉语，很是新鲜。 呼市是一个非常漂亮的城市，天空很蓝。',
          link:'https://touch.travel.qunar.com/youji/6059509?bd_source=RN&showType=share'
        },

        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img7.jpg',
          title:'七月草原+沙漠之旅',
          des:'在最美的季节实现和你的约定',
          link:'https://touch.travel.qunar.com/youji/6859739?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img8.jpg',
          title:'内蒙古—草原沙漠 南方人的北方梦',
          des:'旅途的开始，简单的一句话：在干嘛呢，中秋啥安排我想去呼和浩特，真的是一场说约就约的旅行……',
          link:'https://touch.travel.qunar.com/youji/7530150?bd_source=RN&showType=share'
        },

        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img9.jpg',
          title:'人生的初次旅行',
          des:'揣着一口袋的开心满载而归',
          link:'https://touch.travel.qunar.com/youji/7688109?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img10.jpg',
          title:'寻找内蒙静美的秋韵',
          des:'一直都觊觎着内蒙的辽阔之美，想过夏日青青草原，骑马驰骋，也想过秋日的静美私语，两难中最终还是选择深秋的内蒙。',
          link:'https://touch.travel.qunar.com/youji/7524330?bd_source=RN&showType=share'
        },

        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img11.jpg',
          title:'山西（太原）内蒙（呼市）深度18日游',
          des:'旅途所遇与内心的所思结合起来，明亮了眼眸，充盈了精神，体验了生命，增进了亲子关系，我想这就是旅行带给我们的最伟大的意义！',
          link:'https://touch.travel.qunar.com/youji/7074118?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img12.jpg',
          title:'小小学生党的小旅行',
          des:'天渐渐黑了下来，温度也慢慢降了下来。剩下的时光我尽情的去享受草原的每时每刻。',
          link:'https://touch.travel.qunar.com/youji/4363002?bd_source=RN&showType=share'
        },
        
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img13.jpg',
          title:'三天三座城—内蒙古自驾游',
          des:'一个梦寐已久的远方，一场筹划数次的旅行，没有你，还是要出发。',
          link:'https://touch.travel.qunar.com/youji/6601226?bd_source=RN&showType=share'
        },
        {
          img:'https://source.qunarzz.com/site/images/wns/20220902-shijianchen-img14.jpg',
          title:'呼和浩特呼和塔拉',
          des:'距离呼和浩特最近的草原，也叫万亩草场，也有人称她为青城的“后花园”。',
          link:'https://touch.travel.qunar.com/youji/6925462?bd_source=RN&showType=share'
        }
      ]
    };
  },
  components: {
    appoint,
  },
};
</script>
<style lang='less' scoped='true'>
img {
  display: block;
}
#main {
  background-color: #8cb84b;
}
.cardBox {
  margin: 0 auto;
  width: calc(100% - 20px);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.card {
  background: url(https://source.qunarzz.com/site/images/wns/20220902-shijianchen-card.jpg)
    no-repeat;
  background-size: 100% 100%;
  width: 174px;
  box-sizing: border-box;
  padding-top: 20px;
  margin-bottom: 10px;
  display: block;
  text-decoration: none;
  .card-img {
    width: 150px;
    margin: 0 auto;
  }
  .card-tit {
    padding: 10px;
    padding-bottom: 5px;
    text-align: left;
    color: #6b6b6b;
    font-weight: bold;
    font-size: 15px;
  }
  .card-des {
    font-size: 12px;
    color: #6b6b6b;
    padding: 0 10px 10px;
    text-align: left;
  }
}
</style>